import React, { Component } from 'react';
import { BookOpenIcon, TargetIcon, FlameIcon, ShoppingCartIcon, CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function BundleSection() {
  return <section className="bg-gray-900 text-white py-20 md:py-28 px-4 border-t border-gray-800" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-4">
            Everything You Get in the{' '}
            <span className="text-amber-500" data-id="element-5">$6.36 Bundle</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-6">
            Total Real-World Value:{' '}
            <span className="line-through decoration-red-500 decoration-2" data-id="element-7">
              $398.00
            </span>
          </p>
        </div>

        <div className="space-y-6" data-id="element-8">
          {/* Main Component */}
          <div className="bg-gray-800 border-2 border-amber-500/30 rounded-2xl p-6 md:p-8 relative overflow-hidden" data-id="element-9">
            <div className="absolute top-0 right-0 bg-amber-500 text-neutral-950 font-bold px-4 py-1 rounded-bl-lg text-sm" data-id="element-10">
              MAIN GUIDE
            </div>
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-11">
              <div className="bg-gray-900 p-4 rounded-xl border border-gray-700 shrink-0" data-id="element-12">
                <BookOpenIcon className="w-10 h-10 text-amber-500" data-id="element-13" />
              </div>
              <div data-id="element-14">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-15">
                  <h3 className="text-2xl font-bold" data-id="element-16">The 40+ Vitality Code</h3>
                  <span className="bg-gray-900 text-emerald-400 text-sm font-semibold px-3 py-1 rounded-full border border-emerald-500/20" data-id="element-17">
                    $197 Value
                  </span>
                </div>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-18">
                  The step-by-step 21-day blueprint to reset your sleep,
                  nutrition, and metabolic fire. This is the core protocol that
                  changes everything.
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 1 */}
          <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6 md:p-8" data-id="element-19">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-20">
              <div className="bg-gray-900 p-4 rounded-xl border border-gray-700 shrink-0" data-id="element-21">
                <TargetIcon className="w-10 h-10 text-blue-400" data-id="element-22" />
              </div>
              <div data-id="element-23">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-24">
                  <h3 className="text-2xl font-bold flex items-center gap-2" data-id="element-25">
                    <span data-id="element-26"></span> BONUS 1: Manual de Dopamina Pro
                  </h3>
                  <span className="bg-gray-900 text-emerald-400 text-sm font-semibold px-3 py-1 rounded-full border border-emerald-500/20" data-id="element-27">
                    $97 Value
                  </span>
                </div>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-28">
                  Master your focus. Learn how to eliminate distractions, kill
                  procrastination, and have "CEO-level" concentration during
                  your most important work hours.
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6 md:p-8" data-id="element-29">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-30">
              <div className="bg-gray-900 p-4 rounded-xl border border-gray-700 shrink-0" data-id="element-31">
                <FlameIcon className="w-10 h-10 text-red-400" data-id="element-32" />
              </div>
              <div data-id="element-33">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-34">
                  <h3 className="text-2xl font-bold flex items-center gap-2" data-id="element-35">
                    <span data-id="element-36"></span> BONUS 2: Libido Restoration Guide
                  </h3>
                  <span className="bg-gray-900 text-emerald-400 text-sm font-semibold px-3 py-1 rounded-full border border-emerald-500/20" data-id="element-37">
                    $67 Value
                  </span>
                </div>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-38">
                  Natural Nitric Oxide Protocol. Recover your intimate fire and
                  morning energy using natural precursors found in any grocery
                  store. No drugs. No side effects.
                </p>
              </div>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6 md:p-8" data-id="element-39">
            <div className="flex flex-col md:flex-row gap-6 items-start" data-id="element-40">
              <div className="bg-gray-900 p-4 rounded-xl border border-gray-700 shrink-0" data-id="element-41">
                <ShoppingCartIcon className="w-10 h-10 text-emerald-400" data-id="element-42" />
              </div>
              <div data-id="element-43">
                <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-44">
                  <h3 className="text-2xl font-bold flex items-center gap-2" data-id="element-45">
                    <span data-id="element-46"></span> BONUS 3: 5-Minute Grocery List
                  </h3>
                  <span className="bg-gray-900 text-emerald-400 text-sm font-semibold px-3 py-1 rounded-full border border-emerald-500/20" data-id="element-47">
                    $37 Value
                  </span>
                </div>
                <p className="text-gray-400 text-lg leading-relaxed" data-id="element-48">
                  The Amazon & Supermarket Cheat Sheet. Stop guessing. Buy the
                  specific "Testosterone Foods" and "Dopamine Snacks" that fuel
                  a man's brain and body.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Comparison Box */}
        <div className="mt-12 bg-gray-900/80 border border-gray-800 rounded-2xl p-6 md:p-8 max-w-2xl mx-auto backdrop-blur-sm shadow-2xl" data-id="element-49">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-50">
            <div className="text-center md:text-right" data-id="element-51">
              <p className="text-gray-400 uppercase tracking-wider text-sm font-semibold mb-1" data-id="element-52">
                Regular Price
              </p>
              <p className="text-3xl md:text-4xl text-gray-500 line-through decoration-red-500/50 decoration-4 font-bold" data-id="element-53">
                $197.00
              </p>
            </div>

            <div className="hidden md:block w-px h-16 bg-gray-700" data-id="element-54"></div>

            <div className="text-center md:text-left relative" data-id="element-55">
              <div className="absolute -top-4 -right-8 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-md transform rotate-6 animate-pulse" data-id="element-56">
                92% OFF
              </div>
              <p className="text-amber-500 uppercase tracking-wider text-sm font-bold mb-1" data-id="element-57">
                Introductory Price
              </p>
              <p className="text-5xl md:text-6xl text-white font-extrabold" data-id="element-58">
                $6.36
              </p>
            </div>
          </div>
        </div>

        {/* Summary Box */}
        <div id="buy-now" className="mt-6 bg-neutral-950 border border-gray-800 rounded-2xl p-8 text-center scroll-mt-8" data-id="element-59">
          <h4 className="text-xl text-gray-400 mb-2" data-id="element-60">
            Total Value: <span className="line-through" data-id="element-61">$398.00</span>
          </h4>
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-62">
            Yours Today For Just <span className="text-amber-500" data-id="element-63">$6.36</span>
          </h3>
          <ul className="flex flex-col items-center gap-3 text-gray-300 mb-8" data-id="element-64">
            <li className="flex items-center gap-2" data-id="element-65">
              <CheckCircle2Icon className="w-5 h-5 text-emerald-500" data-id="element-66" /> Instant
              Digital Access
            </li>
            <li className="flex items-center gap-2" data-id="element-67">
              <CheckCircle2Icon className="w-5 h-5 text-emerald-500" data-id="element-68" /> 30-Day
              Money Back Guarantee
            </li>
            <li className="flex items-center gap-2" data-id="element-69">
              <CheckCircle2Icon className="w-5 h-5 text-emerald-500" data-id="element-70" /> Secure
              Checkout
            </li>
          </ul>
          <CTAButton text="YES! I WANT THE FULL BUNDLE — JUST $6.36" className="w-full max-w-lg mx-auto text-xl md:text-2xl py-6 md:py-7" href="https://www.consejossimples.com/cart/53610381967693:1" onClick={() => trackAddToCart()} data-id="element-71" />
          <p className="mt-4 text-gray-500 text-sm" data-id="element-72">
            🔒 Secure 256-bit Encrypted Checkout
          </p>
        </div>
      </div>
    </section>;
}